import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getNumberOfVideosPerRow } from 'utils/common';
import { getRelatedVideosFeatureSelector, getVideosPerPageSelector, viewRangeSelector } from 'common/selectors';

export const Box = ({ boxNumber, children }) => (
  <div className={`ct-video-loader-container__box-wrapper-${boxNumber}`}>
    <div className="ct-video-loader-container__box box_video">{children}</div>
    <div className="ct-video-loader-container__box description" />
    <div className="ct-video-loader-container__box description description-shorter" />
  </div>
);

export const VideoListLoader = connect(
  (state) => ({
    withRelatedVideos: getRelatedVideosFeatureSelector(state),
    viewRange: viewRangeSelector(state),
    perPage: getVideosPerPageSelector(state),
  }),
  false
)(({ errorMsg, numRows, videos, withRelatedVideos, viewRange, perPage, isLoading = true }) => {
  const { t } = useTranslation();

  let rows = [];
  let columns = [];
  let numVideos = getNumberOfVideosPerRow(viewRange, withRelatedVideos);
  let numberOfRows = numRows || perPage / numVideos;
  const showErrorMsg = errorMsg && !isLoading && videos && videos.length === 0;

  for (let i = 0; i < numVideos; i++) {
    const isFirstBox = numRows === 1 && i === 0;

    columns.push(
      <Box key={i} boxNumber={numVideos}>
        {isFirstBox && showErrorMsg ? (
          <div data-e2e="no-videos-message" className="ct-video-loader-container__error-msg">
            <div>{t(errorMsg)}</div>
          </div>
        ) : null}
      </Box>
    );
  }
  for (let i = 0; i < numberOfRows; i++) {
    rows.push(
      <div className="row" key={i}>
        {columns}
      </div>
    );
  }

  if (videos && videos.length > 0 && !isLoading) {
    return null;
  }

  return (
    <div className="ct-video-loader-container">
      <div className={isLoading ? 'ct-video-loader-container__ct-loading-animation' : ''}>{rows}</div>
    </div>
  );
});

VideoListLoader.propTypes = {
  numRows: PropTypes.number,
  numColumns: PropTypes.number,
  errorMsg: PropTypes.string,
  isLoading: PropTypes.bool,
  videos: PropTypes.array,
};
